import { useState, useRef, useCallback, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import "../../assets/scss/defaultFileUpload.scss";
import { const_var } from "../../redux/reducers/reducer";

const FileUpload = ({ show, handleClose }) => {
	const [imageName, setImageName] = useState("");
	const [preview, setPreview] = useState(null);
	const [fileObj, setFileObj] = useState(null);
	const fileInputRef = useRef(null);
	const clearPreview = () => {
		setPreview((prev) => {
			if (prev) URL.revokeObjectURL(prev);
			return null;
		});
	};
	const resetState = () => {
		clearPreview();
		setFileObj(null);
		setImageName("");
		if (fileInputRef.current) fileInputRef.current.value = "";
	};
	const handleFile = useCallback((file) => {
		if (!file || !file.type.startsWith("image/")) return;

		clearPreview();
		const url = URL.createObjectURL(file);
		setPreview(url);
		setFileObj(file);
		setImageName(file.name.replace(/\.[^/.]+$/, ""));
	}, []);
	const onDrop = useCallback(
		(files) => {
			if (files?.length) handleFile(files[0]);
		},
		[handleFile]
	);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		accept: {
			"image/jpeg": [],
			"image/png": []
		},
		multiple: false
	});

	const handleFileChange = (e) => {
		handleFile(e.target.files?.[0]);
	};

	const handleCloseModal = () => {
		resetState();
		handleClose();
	};
	const handleSave = () => {
		if (!fileObj || !imageName.trim()) return;
		const ext = fileObj.name.split(".").pop();
		const renamedFile = new File([fileObj], `${imageName}.${ext}`, { type: fileObj.type });
		const_var.default_Image_object = {
			object: renamedFile,
			name: renamedFile.name
		};
		resetState();
		handleClose();
	};
	useEffect(() => {
		if (const_var?.is_intel_edit && show) {
			setImageName(const_var.default_building_data?.configData?.image_name);
			setPreview(const_var.default_building_data?.imageUrl);
		}
	}, [const_var.default_building_data, show]);
	return (
		<Modal show={show} onHide={handleCloseModal} centered dialogClassName="custom-modal">
			<Modal.Body className="upload-modal">
				<div className="d-flex justify-content-between align-items-center mb-2">
					<h5 className="mb-0">Image Upload</h5>
					<span className="close-btn" onClick={handleCloseModal}>
						×
					</span>
				</div>

				<p className="description">Upload JPEG, JPG, PNG Files only</p>

				<Form.Group className="mb-3">
					<Form.Label>Name</Form.Label>
					<Form.Control type="text" value={imageName} onChange={(e) => setImageName(e.target.value)} placeholder="Enter image name" />
				</Form.Group>

				<div className="upload-box">
					{preview ? (
						<div className="preview-container">
							<span className="remove-img" onClick={resetState}>
								×
							</span>
							<img src={preview} alt="preview" className="preview-img" />
						</div>
					) : (
						<>
							<div {...getRootProps()} className={`drag-area ${isDragActive ? "dragging" : ""}`}>
								<input {...getInputProps()} />
								<img src="https://cdn.sensei3d.com/sheds/static/media/Photo.bf75f39b1da5dac6c9a8c9063ca9916d.svg" alt="upload" className="upload-icon" />
								<p>{isDragActive ? "Drop the image here" : "Drag a photo here"}</p>
							</div>

							<div className="or-divider">-Or-</div>

							<div className="text-center">
								<label className="select-btn">
									<input type="file" accept=".jpeg,.jpg,.png" hidden ref={fileInputRef} onChange={handleFileChange} />+ Select image from your computer
								</label>
							</div>
						</>
					)}
				</div>

				<div className="text-center mt-4">
					<Button className="save-btn" onClick={handleSave} disabled={!fileObj || !imageName.trim()}>
						Save
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default FileUpload;
